let CustomerServicePlatForms = "AV,MK,DT";

export const VALIDATE_CSP = async (csp) => {
  let x = CustomerServicePlatForms.toUpperCase().includes(csp.toUpperCase());
  return x;
};
